<template>
  <div class="user-info1">
    <Nav subNav="个人中心" isShowBack="1"></Nav>
    <div class="wrap1">
      <div class="user-wrap">
        <div
          class="avatar-wrap"
          :class="{
            'avatar-vip-wrap': this.$store.state.user.vip_left > 0,
          }"
        >
          <img :src="this.$store.state.user.avatar" alt="#" />
        </div>
        <div
          class="name-wrap"
          :class="{
            'name-wrap-extra': this.$store.state.user.vip_left > 0,
          }"
        >
          <div class="text1">
            {{ this.$store.state.user.name }}
            <div
              :class="{
                'member-icon': this.$store.state.user.vip_left <= 0,
                'vip-icon': this.$store.state.user.vip_left > 0,
              }"
            >
              {{
                this.$store.state.user.vip_left <= 0 ? "免费会员" : "VIP会员"
              }}
            </div>
          </div>
          <div class="text2">ID:{{ this.$store.state.user.uid }}</div>
          <div class="phone-wrap">
            手机号：
            <div class="phone" v-if="this.$store.state.user.phone">
              {{ this.$store.state.user.phone.substr(0, 3) }}****{{
                this.$store.state.user.phone.substr(7)
              }}
            </div>
            <div v-else class="bind-phone-btn" @click="showMessageClick(6)">
              立即绑定
              <span v-if="!isGetPhoneGrowth">即可获得成长值</span>
            </div>
          </div>
          <div
            class="text3"
            v-if="this.$store.state.user.vip_left > 0 && false"
          >
            到期日期：{{ vipDate }}
          </div>
        </div>
        <div class="device-info-wrap">
          <div class="info-item">
            <div class="item-icon"></div>
            <div class="item-text">我的设备</div>
            <div class="item-line"></div>
            <div class="item-text2">
              {{ this.$store.state.user.device_on_num }} /
              {{
                this.$store.state.user.device_on_num +
                this.$store.state.user.device_off_num
              }}
            </div>
            <div class="item-text3">台</div>
          </div>
          <div class="info-item info-item2">
            <div class="item-icon"></div>
            <div class="item-text">远程服务</div>
            <div class="item-line"></div>
            <div class="item-text2">
              {{
                this.$store.state.user.device_service_on_num +
                this.$store.state.user.vip_service_on_num
              }}
              /
              {{
                this.$store.state.user.device_service_on_num +
                this.$store.state.user.device_service_off_num +
                this.$store.state.user.vip_service_off_num +
                this.$store.state.user.vip_service_on_num
              }}
            </div>
            <div class="item-text3">个</div>
          </div>
        </div>
      </div>
      <div class="become-vip-wrap">
        <div class="become-icon"></div>
        <div class="become-icon2"></div>
        <div
          class="become-btn"
          @click="becomeVipClick"
          v-if="!$store.getters.isAppstoreMode"
        >
          {{ this.$store.state.user.vip_left <= 0 ? "开通会员" : "立即续费" }}
        </div>
        <div class="become-content">
          <div class="become-item">
            <div class="become-item-text">会员权益</div>
            <div class="become-item-text2">免费会员</div>
            <div class="become-item-text3">高级会员</div>
          </div>
          <div class="become-item2">
            <div class="become-item2-a">
              <div class="a1">
                <div class="a-icon"></div>
                绑定设备&nbsp;&nbsp;&nbsp;&nbsp;
              </div>
              <div class="a-line"></div>
              <div class="a1">
                <div class="a-icon a-icon2"></div>
                传输速度&nbsp;&nbsp;&nbsp;&nbsp;
              </div>
              <div class="a-line"></div>
              <div class="a1">
                <div class="a-icon a-icon3"></div>
                相册备份&nbsp;&nbsp;&nbsp;&nbsp;
              </div>
              <!-- <div class="a-line"></div>
              <div class="a1">
                <div class="a-icon a-icon4"></div>
                远程打印&nbsp;&nbsp;&nbsp;&nbsp;
              </div> -->
              <div class="a-line"></div>
              <div class="a1">
                <div class="a-icon a-icon5"></div>
                内网穿透&nbsp;&nbsp;&nbsp;&nbsp;
              </div>
            </div>
            <div class="become-item2-a become-item2-b">
              <div class="a1">{{ $store.state.limit.bind.normal }}台</div>
              <div class="a-line"></div>
              <div class="a1">普通</div>
              <div class="a-line"></div>
              <div class="a1">不支持</div>
              <!-- <div class="a-line"></div>
              <div class="a1">不支持</div> -->
              <div class="a-line"></div>
              <div class="a1">不支持</div>
            </div>
            <div class="become-item2-a become-item2-c">
              <div class="a1">6台</div>
              <div class="a-line"></div>
              <div class="a1">高速</div>
              <div class="a-line"></div>
              <div class="a1">支持</div>
              <!-- <div class="a-line"></div>
              <div class="a1">支持</div> -->
              <div class="a-line"></div>
              <div class="a1">支持</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wrap3">
      <div class="score-wrap">
        <div class="score-title">
          <div class="score-title-icon"></div>
          小宝积分
        </div>
        <div class="score-text">{{ total_points }}</div>
        <div class="go-mall" @click="mallClick">
          <div class="go-mall-icon"></div>
        </div>
      </div>
      <div class="communicate-wrap">
        <div class="communicate-item" @click="showWechatClick">官方社群</div>
        <div
          class="communicate-item communicate-item2"
          @click="showFeedbackClick"
        >
          意见反馈
        </div>
        <div class="communicate-item communicate-item3" @click="goJdxbWebside">
          官方网站
        </div>
      </div>
    </div>
    <div class="wechat-qrcode-wrap" v-if="isShowWechat">
      <div class="white-qrcode-wrap">
        <div class="qrcode-text">加入官方微信群</div>
        <div class="qrcode-icon"></div>
        <div class="qrcode-text2">使用微信扫一扫加入群聊</div>
        <div class="close-qrcode-btn" @click="closeWechatClick"></div>
      </div>
    </div>

    <Tip v-if="tip" :tip="tip"></Tip>

    <Feedback
      v-if="isShowFeedback"
      @closeFeedbackClick="closeFeedbackClick"
    ></Feedback>

    <UserInfoMessage
      @closeMessageClick="closeMessageClick"
      :messageType="messageType"
      v-if="isShowMessage"
    ></UserInfoMessage>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import async from "async";
import Feedback from "@/components/user/Feedback.vue";
import Tip from "@/components/Tip.vue";
import Nav from "@/components/Common/Nav.vue";
import UserInfoMessage from "@/components/UserInfo/UserInfoMessage.vue";

export default {
  name: "UserInfo1",
  components: {
    Tip,
    Nav,
    Feedback,
    UserInfoMessage,
  },
  data: function () {
    return {
      isShowWechat: false,
      isShowFeedback: false,

      tip: "",
      maxWidth: 195,
      myWidth: 0,
      isShowMessage: false,
      messageType: 0, //1等级说明 2活动规则 3加入社群 4意见反馈 5每日签到 6绑定手机
      total_points: 0,
      level: "",
      growth: 0,
      bouns: 0,
      bounsStr: "开通会员享收益加成",
      isGetMonthFeedbackGrowth: false, //默认本月没有领取过积分，所以可领
      isGetPhoneGrowth: false,
      nextLevelGrowth: 100,
      vipDate: "",
      is_sign_in_today: false, //默认今天没签到
      online_service_num: 0,
      all_service_num: 0,
    };
  },
  watch: {
    "$store.state.user.vip_left": function () {
      this.renderVipDate();
    },
  },
  methods: {
    ...mapActions([
      "userPoints",
      "sendUserlog",
      "userGrowthInfo",
      "userSigninInfo",
      "userGrowthTake",
      "scanlist",
      "nodelist",
      "scan",
      "bindget",
    ]),
    showFeedbackClick: function () {
      let _that = this;
      _that.isShowFeedback = true;
    },
    closeFeedbackClick: function () {
      let _that = this;
      _that.isShowFeedback = false;
    },
    goJdxbWebside: function () {
      window.open("https://www.iepose.com");
    },
    showWechatClick: function () {
      let _that = this;
      _that.isShowWechat = true;
    },
    closeWechatClick: function () {
      let _that = this;
      _that.isShowWechat = false;
    },

    phoneBonusClick: function () {
      let _that = this;
      _that.userGrowthTake([
        "phone",
        function (err, data) {
          if (data && data.rtn == 0) {
            if (data.data) {
              _that.myUserGrowthInfo();

              _that.tip = "领取成功";
              setTimeout(function () {
                _that.tip = "";
              }, 1500);
            }
          }
        },
      ]);
    },
    mallClick: function () {
      let _that = this;
      _that.$router.push({ path: "/home/mall" });
    },
    showRuleClick: function () {
      let _that = this;
      _that.showMessageClick(2);
    },
    closeRuleClick: function () {
      let _that = this;
      _that.showMessageClick(5);
    },
    becomeVipClick: function () {
      let _that = this;
      _that.$router.push({ path: "/home/vip" });
    },
    showMessageClick: function (data) {
      let _that = this;
      _that.isShowMessage = true;
      _that.messageType = data;
    },
    closeMessageClick: function () {
      let _that = this;
      _that.isShowMessage = false;
    },
    myUserGrowthInfo: function () {
      let _that = this;
      _that.userGrowthInfo([
        function (err, data) {
          if (data && data.rtn == 0) {
            if (data.data) {
              if (data.data.level) {
                if (data.data.level == 1) {
                  _that.level = "Lv1";
                } else if (data.data.level == 2) {
                  _that.level = "Lv2";
                } else if (data.data.level == 3) {
                  _that.level = "Lv3";
                } else if (data.data.level == 4) {
                  _that.level = "Lv4";
                } else {
                  _that.level = "Lv5";
                }
              }
              if (data.data.growth) {
                _that.growth = data.data.growth;
              }
              if (data.data.bouns != undefined) {
                _that.bouns = data.data.bouns * 100;
                if (_that.$store.state.user.vip_left > 0) {
                  if (_that.bouns == 0) {
                    _that.bounsStr = "绑定手机100成长值";
                  } else {
                    _that.bounsStr = "活跃收益" + _that.bouns + "%";
                  }
                } else {
                  if (_that.bouns == 0) {
                    _that.bounsStr = "开通会员享收益加成";
                  } else {
                    _that.bounsStr = "开通会员" + _that.bouns + "%收益";
                  }
                }
              }

              if (data.data.is_get_month_feedback_growth != undefined) {
                _that.isGetMonthFeedbackGrowth =
                  data.data.is_get_month_feedback_growth;
              }
              if (data.data.is_get_phone_growth != undefined) {
                _that.isGetPhoneGrowth = data.data.is_get_phone_growth;
              }
              if (data.data.next_level_growth != undefined) {
                _that.nextLevelGrowth = data.data.next_level_growth;
              }

              _that.myWidth = parseInt(
                (_that.growth / _that.nextLevelGrowth) * _that.maxWidth
              );
            }
          }
        },
      ]);
    },
    renderVipDate: function () {
      let _that = this;
      let timestamp = new Date().getTime();
      timestamp += _that.$store.state.user.vip_left * 1000;
      _that.vipDate = new Date(timestamp).Format("yyyy-MM-dd");
    },
    myUserSigninInfo: function () {
      let _that = this;
      _that.userSigninInfo([
        function (err, data) {
          if (data && data.rtn == 0) {
            if (data.data) {
              if (data.data.is_sign_in_today != undefined) {
                _that.is_sign_in_today = data.data.is_sign_in_today;
              }
            }
          }
        },
      ]);
    },
    buildServiceInfo: function () {
      let _that = this;
      _that.online_service_num = 0;
      _that.all_service_num = 0;
      for (
        let index = 0;
        index < _that.$store.state.bind_list.length;
        index++
      ) {
        const element = _that.$store.state.bind_list[index];
        if (element.serviceList) {
          for (let j = 0; j < element.serviceList.length; j++) {
            const item = element.serviceList[j];
            _that.all_service_num++;
            if (!item.status) {
              _that.online_service_num++;
            }
          }
        }
      }
    },

    getBindget: function () {
      let _that = this;
      //用户是否有绑定设备
      _that.bindget([
        function (err, data) {
          if (data && !data.rtn) {
            //rtn等于0时，后台不返回此字段
            if (data && data.terms && data.terms.length > 0) {
              // 更新离线在线数量
              let device_off_num = 0;
              let device_on_num = 0;

              _that.list = data.terms;
              _that.termsTermName = _that.list[0].term.comment
                ? _that.list[0].term.comment
                : _that.list[0].term.name
                ? _that.list[0].term.name
                : _that.list[0].peerid;

              _that.$store.state.bind_list = data.terms;

              _that.$store.state.user.isAllLenvNas = false;

              let lenvNasNum = 0;

              for (let index = 0; index < _that.list.length; index++) {
                const element = _that.list[index];
                let pidInfo = _that.$common.getInfoByPid(element.peerid);
                if (pidInfo.cid == 101 || pidInfo.cid == 123) {
                  lenvNasNum++;
                }

                // 构造ip mac 信息
                element.ip = "";
                element.mac = "";

                if (element.term && !element.term.name) {
                  element.term.name = pidInfo.cname + pidInfo.dname;
                }

                if (element.term && element.term.nic) {
                  let nic = _that.$common.getNicByNics(element.term.nic);
                  if (nic) {
                    element.ip = nic.ipv4n;
                    element.mac = nic.mac;
                  }
                }
                if (element.term && element.term.comment) {
                  if (element.term.comment == "0") {
                    element.term.comment = "";
                  }
                }

                if (element.term.status && element.term.status == 1) {
                  ++device_off_num;
                } else {
                  ++device_on_num;
                }
              }
              _that.$store.state.user.device_off_num = device_off_num;
              _that.$store.state.user.device_on_num = device_on_num;

              if (lenvNasNum == _that.list.length && _that.list.length > 0) {
                _that.$store.state.user.isAllLenvNas = true;
              }

              _that.renderServices();
              _that.renderVipServices();
            } else {
              _that.isShowNoBindAlert = true;
            }
          } else if (data && data.rtn == 10109) {
            _that.$common.localStorage.removeItem("jdxb-uid");
            _that.$common.localStorage.removeItem("jdxb-openid");
            _that.$common.localStorage.removeItem("jdxb-name");
            _that.$common.localStorage.removeItem("jdxb-avatar");
            _that.$common.localStorage.removeItem("jdxb-owcode");
            _that.$common.localStorage.removeItem("jdxb-rkey");
            _that.$common.localStorage.removeItem("jdxb-phone");
            _that.$router.push("/login");
          }
        },
      ]);
    },

    renderVipServices: function () {
      let _that = this;
      let services = [];
      //根据设备获取设备服务
      async.eachSeries(
        _that.list,
        function (item, cb) {
          //设备
          let dev = JSON.parse(JSON.stringify(item));
          _that.nodelist([
            item.peerid,
            function (err, data) {
              //获取服务列表放到设备中
              item.serviceList = _that.buildServiceList(data, item);
              //遍历服务列表
              for (let index = 0; index < item.serviceList.length; index++) {
                const element = item.serviceList[index];
                //把设备放到服务中
                element.dev = dev;
                services.push(element);
                _that.allServiceCount++;
              }

              cb ? cb() : null;
            },
          ]);
        },
        function () {
          let device_service_off_num = 0;
          let device_service_on_num = 0;

          for (let index = 0; index < services.length; index++) {
            let element = services[index];
            if (element.status == 1) {
              device_service_off_num++;
            } else {
              device_service_on_num++;
            }
          }
          _that.$store.state.user.vip_service_off_num = device_service_off_num;
          _that.$store.state.user.vip_service_on_num = device_service_on_num;
        }
      );
    },

    buildServiceList: function (data, dev) {
      let _that = this;
      let serviceList = [];
      if (data && !data.rtn && data.jd) {
        //当一个服务有多个端口时，需要展示多个端口
        for (let i = 0; i < data.jd.length; i++) {
          let svs = data.jd[i].svs;
          let item = data.jd[i];
          if (item.dtype) {
            //不显示没有类型的服务
            if (svs) {
              if (svs.length > 0) {
                //有多个端口需要进行拆分
                for (let j = 0; j < svs.length; j++) {
                  let item = JSON.parse(JSON.stringify(data.jd[i]));
                  item.ports = [svs[j].port];
                  item.port = svs[j].port;
                  item.port_name = svs[j].name ? svs[j].name : "";
                  item.rule = svs[j].rule ? svs[j].rule : 0;
                  item.icon = svs[j].icon ? svs[j].icon : 0;
                  item.button = svs[j].button ? svs[j].button : "";
                  // for test
                  // item.icon = "";
                  serviceList.push(item);
                }
              }
            } else {
              //没有端口
              if (item.status == 1) {
                //仅添加离线的能够开机的设备
                serviceList.push(data.jd[i]);
              }
            }
          }
        }

        _that.rebuildListVip(serviceList, dev);
      }
      //  else if (pidInfo.cid == 99) {
      // 	//cid是99的设备
      // 	serviceList.push({
      // 		dtype: 3,
      // 		port: 3389,
      // 		ports: [3389],
      // 		ip: 16777343,
      // 		status: 0,
      // 	});
      // 	_that.rebuildList(serviceList, dev);
      // }
      return serviceList;
    },

    rebuildListVip: function (list, dev) {
      let _that = this;

      let nasWebPort =
        dev.term && dev.term.nasWebPort ? dev.term.nasWebPort : "";

      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        item.ip = item.ip ? item.ip : 0;
        item.ip_str = _that.$common.ipConvert(item.ip);
        item.ip_num = _that.$common.ipConvertToNum(item.ip);

        switch (item.dtype) {
          case 1:
            item.type_name = "NAS";
            break;
          case 2:
            item.type_name = "路由器";
            break;
          case 3:
            item.type_name = "电脑";
            // for test
            // item.status = 1;
            break;
          case 999:
            item.type_name = "自定义服务";
            break;
          default:
            item.type_name = "未知";
            break;
        }

        item.btn = "远程";
        item.port = 80;
        if (!item.name) {
          item.name = item.type_name;
        }
        if (item.ports && item.ports.length > 0) {
          item.port = item.ports[0];
        }
        if (item.ip_str.substr(-2) == ".1" && item.port == 80) {
          item.btn = "远程管理";
        } else if (item.port == 80) {
          item.btn = "浏览网页";
        } else if (
          item.port == 5000 ||
          item.port == 8080 ||
          _that.$store.state.nasExPorts.includes(item.port)
        ) {
          if (item.port == 8800 || item.port == 8801) {
            item.btn = "Audio";
          } else if (item.port == 7000 || item.port == 7001) {
            item.btn = "File";
          } else if (item.port == 5080 || item.port == 5443) {
            item.btn = "Photos";
          } else if (item.port == 9007 || item.port == 9008) {
            item.btn = "Video";
          } else {
            if (item.dtype == 1) {
              item.btn = "NAS管理";
            } else if (item.dtype == 2) {
              item.btn = "路由器管理";
            } else {
              item.btn = "远程管理";
            }
          }
        } else if (item.port == 3389) {
          item.btn = "远程桌面";
        }
        if (item.button) {
          item.btn = item.button;
        }
        if (item.dtype == 999) {
          item.btn = "端口映射";
        }
      }

      for (let index = list.length - 1; index >= 0; index--) {
        const element = list[index];
        // 联想渠道隐藏nas设备
        if (element.dtype == 1 && _that.$store.state.user.isAllLenvNas) {
          list.splice(index, 1);
        } else if (
          element.dtype == 1 &&
          element.port != 5000 &&
          element.port != 8080 &&
          !_that.$store.state.nasExPorts.includes(element.port)
        ) {
          // 遍历删除NAS设备非5000或者非8080端口
          if (nasWebPort) {
            // 考虑有nasWebPort的情况
            if (element.port == nasWebPort && element.mac == dev.mac) {
              element.btn = "NAS管理";
              let pidInfo = _that.$common.getInfoByPid(dev.peerid);
              // 铁威马设备管理端口默认rule=1
              if (pidInfo.cid == 108) {
                element.rule = 1;
              }
            } else {
              list.splice(index, 1);
            }
          } else {
            list.splice(index, 1);
          }
        } else if (
          element.dtype == 3 &&
          element.port != 3389 &&
          !element.status
        ) {
          // 遍历删除在线电脑设备非3389端口
          list.splice(index, 1);
        } else if (element.dtype == 2 && element.port != 80) {
          // 遍历删除路由器设备非80端口
          list.splice(index, 1);
        }
      }

      // 按ip排序
      list.sort(function (a, b) {
        return a.ip_num - b.ip_num;
      });
    },

    renderServices: function () {
      let _that = this;
      let services = [];

      _that.isLoadingServices = true;

      async.eachSeries(
        _that.list,
        function (item, cb) {
          _that.scanServices(item, function (err, data) {
            for (let index = 0; index < data.length; index++) {
              const element = data[index];
              element.dev = item;
              if (item.term && item.term.nic) {
                for (let j = 0; j < item.term.nic.length; j++) {
                  const nic = item.term.nic[j];
                  if (
                    element.mac == nic.mac ||
                    item.peerid.indexOf(element.mac) > -1
                  ) {
                    services.push(element);
                    break;
                  }
                }
              }
            }
            cb ? cb() : null;
          });
        },
        function () {
          _that.isLoadingServices = false;
          _that.serviceList = services;

          let device_service_off_num = 0;
          let device_service_on_num = 0;

          for (let index = 0; index < services.length; index++) {
            let element = services[index];
            if (element.status == 1) {
              device_service_off_num++;
            } else {
              device_service_on_num++;
            }
          }
          _that.$store.state.user.device_service_off_num =
            device_service_off_num;
          _that.$store.state.user.device_service_on_num = device_service_on_num;
        }
      );
    },
    scanServices: function (dev, cb) {
      let _that = this;
      let pidInfo = _that.$common.getInfoByPid(dev.peerid);
      let mac = "";
      if (dev.term && dev.term.nic && dev.term.nic.length > 0) {
        mac = dev.term.nic[0].mac;
      }
      _that.scan([
        dev.peerid,
        function (err, data) {
          let ready = data.ready;
          let timeoutSecond = ready ? 0 : 100;
          setTimeout(function () {
            //扫描服务
            _that.scanlist([
              dev.peerid,
              function (err, data) {
                let searchServiceList = [];
                // if (pidInfo.cid == 99) {
                // 	// 判断在线状态
                // 	if (!(dev.term && dev.term.status)) {
                // 		if (pidInfo.did == 107) {
                // 			// 兼容windows客户端不能服务发现
                // 			searchServiceList.push({
                // 				dtype: 3,
                // 				port: 3389,
                // 				ports: [3389],
                // 				// ip: dev.ip,
                // 				ip: 16777343,
                // 				status:
                // 					dev.term && dev.term.status
                // 						? dev.term.status
                // 						: 0,
                // 				mac: mac,
                // 				btn: "远程桌面",
                // 				name: dev.term.name,
                // 			});
                // 		} else if (pidInfo.did == 108) {
                // 			// 兼容mac客户端不能服务发现
                // 			searchServiceList.push({
                // 				dtype: 3,
                // 				port: 5900,
                // 				ports: [5900],
                // 				// ip: dev.ip,
                // 				ip: 16777343,
                // 				status:
                // 					dev.term && dev.term.status
                // 						? dev.term.status
                // 						: 0,
                // 				mac: mac,
                // 				btn: "远程桌面",
                // 				name: dev.term.name,
                // 			});
                // 		}
                // 	}
                // }
                if (data && !data.rtn && data.jd) {
                  for (let i = 0; i < data.jd.length; i++) {
                    let svs = data.jd[i].svs;
                    // 过滤离线设备
                    if (data.jd[i].status == 1) {
                      continue;
                    }
                    if (data.jd[i].dtype) {
                      //不显示没有类型的服务
                      if (svs) {
                        if (svs.length > 0) {
                          for (let j = 0; j < svs.length; j++) {
                            let item = JSON.parse(JSON.stringify(data.jd[i]));
                            item.ports = [svs[j].port];
                            item.port_name = svs[j].name ? svs[j].name : "";
                            item.rule = svs[j].rule ? svs[j].rule : 0;
                            item.icon = svs[j].icon ? svs[j].icon : "";
                            item.button = svs[j].button ? svs[j].button : "";
                            searchServiceList.push(item);
                          }
                        }
                      } else {
                        //没有端口
                        if (data.jd[i].status == 1) {
                          //仅添加离线的能够开机的设备
                          searchServiceList.push(data.jd[i]);
                        }
                      }
                    }
                  }

                  // console.log(searchServiceList);

                  _that.rebuildList(searchServiceList, dev);
                  cb ? cb(null, searchServiceList) : null;
                  return;
                } else {
                  cb ? cb(null, searchServiceList) : null;
                }
              },
            ]);
          }, timeoutSecond);
        },
      ]);
    },
    rebuildList: function (list, dev) {
      let _that = this;

      let nasWebPort =
        dev.term && dev.term.nasWebPort ? dev.term.nasWebPort : "";

      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        item.ip_str = _that.$common.ipConvert(item.ip);
        item.ip_num = _that.$common.ipConvertToNum(item.ip);

        switch (item.dtype) {
          case 1:
            item.type_name = "NAS";
            break;
          case 2:
            item.type_name = "路由器";
            break;
          case 3:
            item.type_name = "电脑";
            // for test
            // item.status = 1;
            break;
          default:
            item.type_name = "未知";
            break;
        }

        item.btn = "远程";
        item.port = 80;
        if (!item.name) {
          item.name = item.type_name;
        }
        if (item.ports && item.ports.length > 0) {
          item.port = item.ports[0];
        }
        if (item.ip_str.substr(-2) == ".1" && item.port == 80) {
          item.btn = "远程管理";
          if (item.dtype == 1) {
            item.btn = "NAS管理";
          } else if (item.dtype == 2) {
            item.btn = "路由器管理";
          }
        } else if (item.port == 80) {
          item.btn = "浏览网页";
          if (item.dtype == 1) {
            item.btn = "NAS管理";
          } else if (item.dtype == 2) {
            item.btn = "路由器管理";
          }
        } else if (
          item.port == 5000 ||
          item.port == 8080 ||
          _that.$store.state.nasExPorts.includes(item.port)
        ) {
          if (item.port == 8800 || item.port == 8801) {
            item.btn = "Audio";
          } else if (item.port == 7000 || item.port == 7001) {
            item.btn = "File";
          } else if (item.port == 5080 || item.port == 5443) {
            item.btn = "Photos";
          } else if (item.port == 9007 || item.port == 9008) {
            item.btn = "Video";
          } else {
            if (item.dtype == 1) {
              item.btn = "NAS管理";
            } else if (item.dtype == 2) {
              item.btn = "路由器管理";
            } else {
              item.btn = "远程管理";
            }
          }
        } else if (item.port == 3389) {
          item.btn = "远程桌面";
        }

        if (item.button) {
          item.btn = item.button;
        }
      }

      for (let index = list.length - 1; index >= 0; index--) {
        const element = list[index];
        // 联想渠道隐藏nas设备
        if (element.dtype == 1 && _that.$store.state.user.isAllLenvNas) {
          list.splice(index, 1);
        } else if (element.dtype == 1 && element.port == 80) {
          // nas过滤80
          list.splice(index, 1);
        }
        //  else if (
        // 	element.dtype == 1 &&
        // 	element.port != 5000 &&
        // 	element.port != 8080 &&
        // 	!_that.$store.state.nasExPorts.includes(element.port)
        // ) {
        // 	// 遍历删除NAS设备非5000或者非8080端口
        // 	if (nasWebPort) {
        // 		// 考虑有nasWebPort的情况
        // 		if (
        // 			element.port == nasWebPort &&
        // 			element.mac == dev.mac
        // 		) {
        // 			element.btn = "NAS管理";
        // 			let pidInfo = _that.$common.getInfoByPid(
        // 				_that.curDev.peerid
        // 			);
        // 			// 铁威马设备管理端口默认rule=1
        // 			if (pidInfo.cid == 108) {
        // 				element.rule = 1;
        // 			}
        // 		} else {
        // 			list.splice(index, 1);
        // 		}
        // 	} else {
        // 		list.splice(index, 1);
        // 	}
        // } else if (
        // 	element.dtype == 3 &&
        // 	element.port != 3389 &&
        // 	!element.status
        // ) {
        // 	// 遍历删除在线电脑设备非3389端口
        // 	list.splice(index, 1);
        // } else if (element.dtype == 2 && element.port != 80) {
        // 	// 遍历删除路由器设备非80端口
        // 	list.splice(index, 1);
        // }
      }
      // nasWebPort端口
      if (nasWebPort) {
        let isServiceHasNasWebPort = false;
        for (let index = 0; index < list.length; index++) {
          // 检查nasWebPort是否已经在服务列表
          const element = list[index];
          if (element.mac == dev.mac && element.port == nasWebPort) {
            isServiceHasNasWebPort = true;
            break;
          }
        }
        if (!isServiceHasNasWebPort) {
          let isHas = false;
          for (let index = 0; index < list.length; index++) {
            const element = list[index];
            if (element.mac == dev.mac && element.port == nasWebPort) {
              isHas = true;
              break;
            }
          }
          if (!isHas) {
            list.push({
              dtype: 1,
              ip: dev.ip,
              mac: dev.mac,
              name: dev.term.name ? dev.term.name : "nas",
              port: nasWebPort,
              ports: [nasWebPort],
              btn: "NAS管理",
            });
          }
        }
      }

      // 按ip排序
      list.sort(function (a, b) {
        return a.ip_num - b.ip_num;
      });
    },
  },
  computed: {},
  activated() {
    let _that = this;
  },
  mounted() {
    let _that = this;
    // _that.myUserSigninInfo();
    // _that.myUserGrowthInfo();
    // _that.buildServiceInfo();
    //
    // _that.renderVipDate();

    _that.getBindget();

    _that.userPoints([
      function (err, data) {
        if (data && data.rtn == 0) {
          if (data.data.left_points) {
            _that.total_points = data.data.left_points;
          }
        }
      },
    ]);
  },
};
</script>
<style lang="less" scoped>
.user-info1 {
  height: 100%;
  width: 100%;
  box-sizing: border-box;

  .bg {
    background-position: center;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .wrap1 {
    display: inline-block;
    margin-left: 12px;

    .user-wrap {
      position: relative;
      padding-top: 1px;
      width: 650px;
      height: 145px;
      box-sizing: border-box;
      .bg();
      background-image: url("../assets/userinfov2/userinfo1.png");
      box-shadow: 0px 3px 10px rgba(111, 111, 111, 0.1);
      border-radius: 4px;

      .avatar-wrap {
        display: inline-block;
        margin-top: 28px;
        margin-left: 36px;
        width: 96px;
        height: 96px;
        border-radius: 50%;
        overflow: hidden;
        border: 1px solid #a2abc0;

        img {
          width: 100%;
          height: 100%;
        }
      }
      .avatar-vip-wrap {
        border: 1px solid #ebb63e;
      }
      .name-wrap {
        display: inline-block;
        vertical-align: top;
        margin-top: 34px;
        margin-left: 15px;
        .text1 {
          color: #1a1a1a;
          font-weight: 700;
          font-size: 17px;

          .member-icon,
          .vip-icon {
            display: inline-block;
            padding-left: 30px;
            padding-top: 1px;
            margin-left: 5px;
            width: 82px;
            height: 28px;
            line-height: 28px;
            box-sizing: border-box;
            font-size: 12px;
            font-weight: normal;

            .bg();
            background-image: url("../assets/userinfo/userinfo6.png");
          }
          .member-icon {
            padding-left: 28px;
          }
          .vip-icon {
            background-image: url("../assets/userinfo/userinfo7.png");
          }
        }
        .text2 {
          margin-top: 6px;
          line-height: 16px;
          font-size: 14px;
        }
        .phone-wrap {
          margin-top: 6px;
          font-size: 14px;

          .phone {
            display: inline-block;
          }
          .bind-phone-btn {
            position: relative;
            display: inline-block;
            width: 68px;
            height: 22px;
            line-height: 22px;
            background-image: linear-gradient(to right, #f8d4b9, #f3cfc0);
            border-radius: 20px;
            color: #e25132;
            text-align: center;
            cursor: pointer;

            span {
              position: absolute;
              left: 75px;
              white-space: nowrap;
              font-size: 12px;
            }
          }
        }
        .text3 {
          margin-top: 6px;
          font-size: 14px;
          color: #877859;
        }
      }

      .name-wrap-extra {
        margin-top: 45px;

        .text1 {
          color: #86631b;
        }
        .text2 {
          color: #4a3508;
        }
        .phone-wrap {
          color: #4a3508;
        }
      }
      .device-info-wrap {
        display: inline-block;
        margin-top: 24px;
        margin-left: 110px;
        vertical-align: top;
        height: 98px;
        min-width: 120px;
        border-left: 1px solid #d9e1ef;
        .info-item {
          padding-top: 24px;
          padding-left: 27px;
          .item-icon,
          .item-text,
          .item-line,
          .item-text2,
          .item-text3 {
            display: inline-block;
            vertical-align: top;
          }
          .item-icon {
            margin-top: -1px;
            width: 16px;
            height: 16px;
            background-image: url("../assets/userinfov2/userinfo2.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
          }
          .item-text {
            margin-left: 4px;
            font-size: 12px;
            line-height: 16px;
            color: #666666;
          }
          .item-line {
            margin-left: 14px;
            margin-top: 1px;
            width: 1px;
            height: 14px;
            background-color: #d9e1ef;
          }
          .item-text2 {
            margin-top: -4px;
            margin-left: 12px;
            font-weight: 700;
            font-size: 20px;
            line-height: 24px;
            color: #3e3f4e;
          }
          .item-text3 {
            margin-left: 8px;
            line-height: 16px;
            font-size: 12px;
            color: #999999;
          }
        }
        .info-item2 {
          padding-top: 16px;
          .item-icon {
            background-image: url("../assets/userinfov2/userinfo12.png");
          }
        }
      }
    }
    .become-vip-wrap {
      margin-top: 12px;
      padding-top: 1px;
      width: 650px;
      height: 335px;
      box-sizing: border-box;
      border-radius: 4px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-image: url("../assets/userinfov2/userinfo3.png");
      box-shadow: 0px 3px 14px rgba(159, 157, 144, 0.2);
      .become-icon,
      .become-icon2,
      .become-btn {
        display: inline-block;
        vertical-align: top;
      }
      .become-btn:hover {
        cursor: pointer;
        opacity: 0.9;
      }
      .become-icon {
        margin-top: 24px;
        margin-left: 28px;
        width: 46px;
        height: 44px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url("../assets/userinfov2/userinfo4.png");
      }
      .become-icon2 {
        margin-top: 26px;
        margin-left: 10px;
        width: 210px;
        height: 36px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url("../assets/userinfov2/userinfo5.png");
      }
      .become-btn {
        margin-left: 148px;
        margin-top: 24px;
        width: 180px;
        height: 46px;
        background: linear-gradient(
          94deg,
          #f2d7b3 18%,
          #e9c29b 52%,
          #d9ad84 80%
        );
        box-shadow: 0px 3px 10px rgba(131, 106, 46, 0.1);
        border-radius: 56px;
        line-height: 46px;
        font-weight: 700;
        font-size: 16px;
        color: #5f4509;
        text-align: center;
        cursor: pointer;
      }
      .become-content {
        position: relative;
        margin: 0 auto;
        margin-top: 16px;
        width: 626px;
        height: 236px;
        background: linear-gradient(
          180deg,
          #ffd4a3 0%,
          #edc598 53%,
          #ffddbe 100%
        );
        box-shadow: 0px 3px 14px rgba(158, 177, 197, 0.3);
        border-radius: 4px;
        .become-item {
          padding-top: 16px;
          text-align: center;
          font-weight: 600;
          font-size: 16px;
          line-height: 22px;
          color: #5b3d15;
          .become-item-text,
          .become-item-text2,
          .become-item-text3 {
            display: inline-block;
            vertical-align: top;
          }
          .become-item-text {
            width: 218px;
          }
          .become-item-text2 {
            margin-left: 7px;
            margin-right: 7px;
            width: 187px;
          }
          .become-item-text3 {
            width: 187px;
          }
        }
        .become-item2 {
          margin-top: 8px;
          text-align: center;
          .become-item2-a,
          .become-item2-b,
          .become-item2-c {
            display: inline-block;
            vertical-align: top;
          }
          .become-item2-a {
            width: 218px;
            // height: 180px;
            background: #ffffff;
            opacity: 0.7;
            border-radius: 4px;
            .a1 {
              // line-height: 36px;
              line-height: 44px;
              font-size: 14px;
              color: #000000;
              .a-icon {
                display: inline-block;
                margin-right: 4px;
                // margin-top: 5px;
                margin-top: 11px;
                vertical-align: top;
                width: 24px;
                height: 24px;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                background-image: url("../assets/userinfov2/vip-icon-01.png");
              }
              .a-icon2 {
                background-image: url("../assets/userinfov2/vip-icon-02.png");
              }
              .a-icon3 {
                background-image: url("../assets/userinfov2/vip-icon-03.png");
              }
              .a-icon4 {
                background-image: url("../assets/userinfov2/vip-icon-04.png");
              }
              .a-icon5 {
                background-image: url("../assets/userinfov2/vip-icon-05.png");
              }
            }
            .a-line {
              margin: 0 auto;
              margin-top: -1px;
              width: 177px;
              height: 1px;
              background-color: rgba(199, 192, 183, 0.4);
            }
          }
          .become-item2-b,
          .become-item2-c {
            margin-left: 7px;
            width: 187px;
            .a-line {
              width: 144px;
            }
          }
          .become-item2-c {
            .a-line {
              width: 146px;
            }
          }
        }
      }
      .become-content::before {
        position: absolute;
        left: 20px;
        top: 2px;
        content: "";
        width: 72px;
        height: 44px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url("../assets/userinfov2/userinfo6.png");
      }
      .become-content::after {
        position: absolute;
        right: 10px;
        top: 10px;
        content: "";
        width: 70px;
        height: 36px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url("../assets/userinfov2/userinfo7.png");
      }
    }
  }
  .wrap3 {
    display: inline-block;
    margin-left: 12px;
    vertical-align: top;
    .score-wrap {
      padding-top: 1px;
      width: 270px;
      height: 253px;
      box-shadow: 0px 3px 10px rgba(111, 111, 111, 0.1);
      border-radius: 4px;
      background-image: url("../assets/userinfov2/userinfo13.png");
      background-repeat: no-repeat;
      background-size: 100% 172px;
      background-position: top;
      box-sizing: border-box;
      .score-title {
        margin-top: 22px;
        margin-left: 23px;
        font-weight: 700;
        font-size: 14px;
        line-height: 24px;
        color: #1a1a1a;
        .score-title-icon {
          display: inline-block;
          margin-right: 4px;
          vertical-align: top;
          width: 24px;
          height: 24px;
          background-image: url("../assets/userinfov2/userinfo14.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
      .score-text {
        margin-top: 27px;
        font-weight: 700;
        font-size: 28px;
        line-height: 34px;
        color: #453c2f;
        text-align: center;
        font-family: "DIN";
      }
      .go-mall {
        padding-top: 1px;
        margin: 0 auto;
        margin-top: 29px;
        width: 246px;
        height: 102px;
        box-shadow: 0px 4px 8px rgba(199, 189, 175, 0.3);
        border-radius: 4px;
        background-image: url("../assets/userinfov2/userinfo15.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        box-sizing: border-box;
        cursor: pointer;
        .go-mall-icon {
          margin-top: 61px;
          margin-left: 16px;
          width: 100px;
          height: 20px;
          background-image: url("../assets/userinfov2/userinfo16.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .go-mall:hover {
      cursor: pointer;
      opacity: 0.9;
    }
    .communicate-wrap {
      padding-top: 1px;
      margin-top: 12px;
      width: 270px;
      height: 225px;
      box-shadow: 0px 3px 10px rgba(111, 111, 111, 0.1);
      border-radius: 4px;
      box-sizing: border-box;
      background-color: #ffffff;
      .communicate-item {
        position: relative;
        padding-top: 17px;
        padding-left: 40px;
        margin: 0 auto;
        margin-top: 20px;
        width: 246px;
        height: 56px;
        background: #fff9f9;
        border: 1px solid #fbf4f1;
        border-radius: 8px;
        font-weight: 600;
        font-size: 14px;
        color: #666666;
        box-sizing: border-box;
        cursor: pointer;
      }
      .communicate-item::before {
        position: absolute;
        content: "";
        right: 16px;
        bottom: 0px;
        width: 48px;
        height: 36px;
        background-image: url("../assets/userinfov2/userinfo17.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .communicate-item:hover {
        background: #fff9f9;
        border: 1px solid #fdd9c7;
        box-shadow: 0px 3px 8px rgba(179, 179, 179, 0.3);
      }
      .communicate-item2 {
        margin-top: 8px;
        background: #f9fcff;
        border: 1px solid #f1f4fb;
      }
      .communicate-item2::before {
        background-image: url("../assets/userinfov2/userinfo18.png");
      }
      .communicate-item2:hover {
        background: #f9fcff;
        border: 1px solid #c7d6fd;
        box-shadow: 0px 3px 8px rgba(178, 178, 178, 0.3);
      }
      .communicate-item3 {
        margin-top: 8px;
        background: #f9f9ff;
        border: 1px solid #f5f1fb;
      }
      .communicate-item3::before {
        background-image: url("../assets/userinfov2/userinfo19.png");
      }
      .communicate-item3:hover {
        background: #f9f9ff;
        border: 1px solid #cfc7fd;
        box-shadow: 0px 3px 8px rgba(178, 178, 178, 0.3);
      }
    }
  }
  .wechat-qrcode-wrap {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    .white-qrcode-wrap {
      position: absolute;
      padding-top: 1px;
      left: 50%;
      top: 50%;
      width: 303px;
      height: 340px;
      transform: translate(-50%, -50%);
      background-color: #ffffff;
      border-radius: 8px;
      box-sizing: border-box;
      .qrcode-text {
        margin-top: 28px;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        text-align: center;
        color: #143977;
      }
      .qrcode-icon {
        margin: 0 auto;
        margin-top: 14px;
        width: 200px;
        height: 200px;
        background-image: url("https://cdn.ionewu.com/jdxb_www/images/wechat-group.jpg");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .qrcode-text2 {
        margin-top: 10px;
        font-size: 12px;
        line-height: 24px;
        text-align: center;
        color: #666666;
      }
      .close-qrcode-btn {
        margin: 0 auto;
        margin-top: 45px;
        padding: 20px;
        width: 34px;
        height: 34px;
        background-image: url("../assets/userinfov2/userinfo21.svg");
        background-repeat: no-repeat;
        background-size: 34px 34px;
        background-position: center;
        cursor: pointer;
      }
    }
  }
  .wrap2 {
    display: inline-block;
    padding-top: 1px;
    margin-left: 10px;
    padding-left: 13px;
    padding-right: 13px;
    vertical-align: top;
    height: 499px;
    width: 258px;
    box-sizing: border-box;
    box-shadow: 0 3px 10px 1px rgba(111, 111, 111, 0.12);
    border: 1px solid #d1d1d2;
    border-radius: 3px;
    .bg();
    background-image: url("../assets/userinfo/userinfo11.png");

    .title1,
    .title2 {
      margin-top: 19px;
      position: relative;
      font-size: 14px;
      padding-left: 23px;
      font-weight: bolder;
    }
    .title1::before,
    .title2::before {
      position: absolute;
      left: 0;
      content: "";
      width: 20px;
      height: 20px;
      .bg();
      background-position: left center;
      background-image: url("../assets/userinfo/userinfo10.svg");
    }
    .title2::before {
      background-image: url("../assets/userinfo/userinfo9.svg");
    }

    .points {
      margin-top: 35px;
      text-align: center;
      font-size: 36px;
      color: #1a1a1a;
      font-weight: 500;
      height: 40px;
      font-weight: bolder;
    }
    .mall-btn {
      position: relative;
      margin: 0 auto;
      margin-top: 30px;
      margin-bottom: 50px;
      text-align: left;
      padding-left: 52px;
      width: 128px;
      height: 34px;
      line-height: 34px;
      background-image: linear-gradient(to right, #fdefd5, #ffe1c5);
      color: #f57c4e;
      box-sizing: border-box;
      border-radius: 36px;
    }
    .mall-btn:hover {
      cursor: pointer;
      opacity: 0.8;
    }
    .mall-btn::before {
      position: absolute;
      top: 7px;
      left: 28px;
      content: "";
      width: 20px;
      height: 20px;
      .bg();
      background-image: url("../assets/userinfo/userinfo12.svg");
    }
    .task-wrap {
      position: relative;
      margin-top: 10px;
      padding: 14px;
      height: 225px;
      width: 100%;
      background-color: #ffffff;
      border-radius: 3px;
      box-sizing: border-box;
      box-shadow: 0 3px 10px 1px rgba(217, 217, 217, 0.17);
      .phone-bonus-btn {
        position: absolute;
        right: 12px;
        top: 8px;
        text-align: center;
        width: 92px;
        height: 24px;
        line-height: 24px;
        background-image: linear-gradient(to right, #fdefd5, #ffe1c5);
        color: #f57c4e;
        box-sizing: border-box;
        cursor: pointer;
        border-radius: 36px;
      }
      .text1,
      .text2 {
        display: inline-block;
      }
      .text1 {
        font-size: 15px;
        color: #3e455f;
        font-weight: 700;
      }
      .text2 {
        margin-left: 3px;
      }
      .progress-wrap {
        position: relative;
        padding-top: 2px;
        margin-top: 12px;
        padding-left: 2px;
        width: 204px;
        height: 14px;
        background-color: #e5e5ed;
        border-radius: 31px;
        box-sizing: border-box;

        .progress {
          height: 10px;
          width: 200px;
          border-radius: 31px;
          background-image: linear-gradient(
            to left,
            #a12b11,
            #fb4a22,
            #f4672b,
            #e76f3b,
            #ff9d43
          );
        }
        .icon1 {
          position: absolute;
          padding-right: 17px;
          top: -12px;
          left: 4px;
          /*width: 18px;*/
          width: 0px;
          height: 20px;
          .bg();
          background-image: url("../assets/userinfo/userinfo13.png");
          background-position: right center;
          background-size: 17px 100%;
        }
      }

      .btn1-wrap {
        position: relative;
        margin-top: 22px;
        width: 100%;

        .btn1 {
          display: inline-block;
          color: #f3863f;
          padding: 4px 10px;
          background-color: rgba(243, 134, 63, 0.08);
          border: 1px solid rgba(243, 134, 63, 0.36);
          border-radius: 3px;
        }
        .level-text-btn {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translate(0, -50%);
          padding-right: 17px;
          .bg();
          background-position: right center;
          background-size: 17px 17px;
          background-image: url("../assets/userinfo/userinfo14.svg");
          color: #999999;
          cursor: pointer;
        }
      }
      .line {
        margin-top: 10px;
        width: 100%;
        height: 1px;
        background-color: #f8f9fb;
      }

      .btn2,
      .btn3,
      .btn4,
      .btn5 {
        position: relative;
        padding-left: 38px;
        font-size: 14px;
        width: 100%;
        height: 31px;
        line-height: 31px;
        background-position: left center;
        background-size: 31px 31px;
        background-repeat: no-repeat;
        box-sizing: border-box;
      }
      .btn2 {
        margin-top: 16px;
        background-image: url("../assets/userinfo/userinfo15.svg");

        .goSigninBtn {
          position: absolute;
          right: 0px;
          top: 3px;
          width: 60px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          border-radius: 31px;
          box-shadow: 0 2px 3px 0px rgba(217, 189, 183, 0.19);
          font-size: 12px;
          color: #ee7155;
          background-color: #ffd5cc;
          border: 1px solid #f4c0c0;
        }
        .goSigninBtn:hover {
          cursor: pointer;
          opacity: 0.8;
        }
      }
      .btn3 {
        background-image: url("../assets/userinfo/userinfo18.svg");

        .goFeedbackBtn {
          position: absolute;
          right: 0px;
          top: 3px;
          width: 60px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          border-radius: 31px;
          box-shadow: 0 2px 3px 0px rgba(217, 189, 183, 0.19);
          font-size: 12px;
          color: #55a5ee;
          background-color: #d6ebff;
          border: 1px solid #cce2f6;
        }
        .goFeedbackBtn:hover {
          cursor: pointer;
          opacity: 0.8;
        }
      }
      .btn4 {
        background-image: url("../assets/userinfo/userinfo17.svg");

        .goJoinBtn {
          position: absolute;
          right: 0px;
          top: 3px;
          width: 60px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          border-radius: 31px;
          box-shadow: 0 2px 3px 0px rgba(217, 189, 183, 0.19);
          cursor: pointer;
          font-size: 12px;
          color: #5577ee;
          background-color: #d1e0fe;
          border: 1px solid #c2c7f8;
        }
        .goJoinBtn:hover {
          cursor: pointer;
          opacity: 0.8;
        }
      }
      .btn5 {
        background-image: url("../assets/userinfo/userinfo16.svg");
      }
      .btn5::after {
        content: "去绑定";
        position: absolute;
        right: 0px;
        top: 3px;
        width: 58px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 31px;
        box-shadow: 0 2px 3px 0px rgba(217, 189, 183, 0.19);
        cursor: pointer;
        font-size: 12px;
        color: #ee7155;
        background-color: #feecd1;
        border: 1px solid #f6e5cc;
      }

      .line2 {
        margin-top: 8px;
        margin-bottom: 8px;
        width: 100%;
        height: 1px;
        background-color: rgba(211, 211, 219, 0.24);
      }
    }
  }
}
</style>
